import {Helmet} from "react-helmet";
import React, {useState} from "react";
import {Paper} from "@mui/material";
import {TagTable} from "../component/tags/TagTable";
import {CreateTagModal} from "../component/tags/CreateTagModal";
import CustomBtn from "../component/customBtns/CustomBtn";

export const TagContainer = () => {
    const [needFetch, setNeedFetch] = useState(false);
    const [openCreateTagModal, setOpenCreateTagModal] = useState(false)

    const fontWeightTitle = {
        fontWeight:"600"
    };


    return (
        <div className="d-flex justify-content-center">
            <Helmet>
                <title>Gérer les Tags</title>
            </Helmet>
            <Paper className="py-4 px-4 rounded shadow-none App-container w-100 m-0">
                <div className={"d-flex flex-row justify-content-between"}>
                    <h3 className='mb-4' style={fontWeightTitle}>Tags</h3>
                    <CustomBtn
                        label="Créer un tag"
                        bgColor="#299CDB"
                        iconBg={"#3ba9e5"}
                        icon={"+"}
                        click={() => setOpenCreateTagModal(true)}
                    />
                </div>
                <div className='overflow-auto'>
                    <TagTable needFetch={needFetch}></TagTable>
                </div>
            </Paper>
            <CreateTagModal
                open={openCreateTagModal}
                onTagSaved={(e) => {
                    setOpenCreateTagModal(false)
                    setNeedFetch(!needFetch)
                }}
                onClose={() => setOpenCreateTagModal(false)}
            />
        </div>
)
}